import { decryptToAsciiString } from "../../utils/dataEncryption";
import { collectAndPrintToConsoleLog, concatLogsAndVars, createEmptyLogsAndVars, dwReportError, recordVariable, ReportingError, } from "../../utils/diagnostics/clientErrors";
import { notifyMpcWalletOnUserSharesStored, refreshClientSessionTokenByRecoveryToken, } from "../../utils/dwclient/dwclientutils";
import { sendMessageWithNcSignature } from "../../utils/dwclient/dwcommonutils";
import { storeUserShares } from "../../utils/dwclient/localstorage/userShareStorage";
import { recover as portalHqUserShareRecover } from "../../utils/dwclient/portalhqutils";
import { storeClientId } from "../../utils/dwclient/localstorage/clientIdStorage";
import { storeClientSessionToken } from "../../utils/dwclient/localstorage/clientSessionTokenStorage";
export async function recoverMpcWallet(walletAddress, wallet) {
    let logsAndVars = createEmptyLogsAndVars("recoverMpcWallet:recoverMpcWallet");
    let receivedClientId;
    try {
        //console.log("recoverMpcWallet:recoverMpcWallet", walletAddress, wallet);
        const backupSharesResp = await retrieveBackupSharesFromBackend(walletAddress, wallet);
        //console.log("1", backupSharesResp);
        recordVariable(logsAndVars, "backupSharesResp", backupSharesResp);
        //const receivedClientId = await decryptToAsciiString(backupSharesResp.encClientId);
        const receivedBackupSharesString = await decryptToAsciiString(wallet.provider, backupSharesResp.backupInfo.encBackupShares);
        //console.log("2", receivedBackupSharesString);
        recordVariable(logsAndVars, "receivedBackupSharesString", receivedBackupSharesString);
        receivedClientId = await decryptToAsciiString(wallet.provider, backupSharesResp.backupInfo.encClientId);
        //console.log("3", receivedClientId);
        await storeClientId(wallet.provider, receivedClientId);
        //console.log("4");
        const receivedEthWalletAddress = await decryptToAsciiString(wallet.provider, backupSharesResp.backupInfo.encEthWalletAddress);
        //console.log("5", receivedEthWalletAddress);
        const receivedSolanaWalletAddress = await decryptToAsciiString(wallet.provider, backupSharesResp.backupInfo.encSolanaWalletAddress);
        //console.log("6", receivedSolanaWalletAddress);
        const receivedBackupSharesObj = JSON.parse(receivedBackupSharesString);
        const recoveryAuthToken = backupSharesResp.authToken;
        const clientSessionTokenHolder = await refreshClientSessionTokenByRecoveryToken(recoveryAuthToken, receivedClientId);
        const clientSessionToken = clientSessionTokenHolder.clientSessionToken;
        await storeClientSessionToken(wallet.provider, clientSessionToken);
        recordVariable(logsAndVars, "clientSessionToken", clientSessionToken);
        const userShares = await portalHqUserShareRecover(clientSessionToken, receivedBackupSharesObj);
        recordVariable(logsAndVars, "userShares", userShares);
        const userSharesString = JSON.stringify(userShares);
        await storeUserShares(wallet.provider, userSharesString);
        collectAndPrintToConsoleLog(logsAndVars, "user shares stored");
        await notifyMpcWalletOnUserSharesStored(clientSessionToken, userShares.SECP256K1.id, userShares.ED25519.id);
        collectAndPrintToConsoleLog(logsAndVars, "PortalHQ notified on user shares stored.");
        collectAndPrintToConsoleLog(logsAndVars, "recovery of MPC user share finished.");
        return {
            clientId: receivedClientId,
            clientSessionToken,
            userSharesString,
            ethWalletAddress: receivedEthWalletAddress,
            solanaWalletAddress: receivedSolanaWalletAddress,
            authToken: null,
        };
    }
    catch (error) {
        if (error?.cause?.response?.data?.details && error?.cause?.response?.data?.details.includes("object not found")) {
            return {
                clientId: null,
                clientSessionToken: null,
                userSharesString: null,
                authToken: null,
                ethWalletAddress: null,
                solanaWalletAddress: null,
            };
        }
        if (error instanceof ReportingError) {
            logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
        }
        dwReportError(walletAddress, receivedClientId, error, { logsAndVars });
        console.trace("hiba");
        throw new ReportingError(error, logsAndVars);
    }
}
// MPC Wallet Management Service / 9. Recover User MPC Wallet Backup Info
async function retrieveBackupSharesFromBackend(walletAddress, wallet) {
    const myApiVersion = process.env.API_VERSION || "1.0";
    const postObject = {
        method: "get",
        endpoint: `/api/${myApiVersion}/mpc/recover`,
        ncwa: walletAddress,
    };
    return sendMessageWithNcSignature(wallet.provider, walletAddress, postObject);
}
/*async function refreshClientSessionTokenWithJWT(clientId: string, jwt: string) {
  const logsAndVars: LogsAndVarsType = createEmptyLogsAndVars("recoverMpcWallet:refreshClientSessionTokenWithJWT");
  try {
    const baseUrl =
      //process.env.DWINITY_BACKEND_FOR_CLIENT_SESSION_TOKEN_CHECK ??
      process.env.DWINITY_BACKEND ?? "https://api.dev.dwinity.com";
    const myApiVersion = "0.3";
    const url = `${baseUrl}/api/${myApiVersion}/mpc/refresh`;
    recordVariable(logsAndVars, "url", url);
    recordVariable(logsAndVars, "clientId (query param)", clientId);
    const response: AxiosResponse<ClientSessionTokenHolder> = await axios.get(url, {
      params: {
        clientId: clientId,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwt,
      },
    });
    recordVariable(logsAndVars, "response", response);
    return response.data;
  } catch (error: any) {
    await recordPotentialAxiosError(logsAndVars, error);
    dwReportError(null, undefined, error, { logsAndVars });
    throw new ReportingError(error.message, logsAndVars);
  }
}
*/
